import { baseLocalStorage } from "@/lib/storage";

export const deviceInfo = () => {
  const ip = null; // await getIp();
  const os = getOs();
  const model_nm = getModel();
  return { ip, os, model_nm };
};
export const getIp = async () => {
  // const re = await axios.get('https://api.ipify.org?format=json');
  // if (re.status !== 200) {
  //   return null;
  // }
  // return re.data.ip;
};
export const getOs = () => {
  const re = baseLocalStorage('device_os');
  if (!re) {
    return null;
  }
  return re;
};

export const getModel = () => {
  const re = baseLocalStorage('device_model');
  if (!re) {
    return null;
  }
  return re;
};

export const getPushId = () => {
  const re = baseLocalStorage('pushid');
  if (!re) {
    return null;
  }
  return re;
};